import { telnyxPhoneNumberApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TELNYX_PHONE_NUMBERS_ACTION_TYPE = createNamedActions('telnyxPhoneNumbers', {
  GET_COMPANY_PHONE_NUMBERS: 'GET_COMPANY_PHONE_NUMBERS',
  SEARCH_AVAILABLE_NUMBERS: 'SEARCH_AVAILABLE_NUMBERS',
  CLEAR_SEARCH_RESULTS: 'CLEAR_SEARCH_RESULTS',
  ORDER_PHONE_NUMBERS: 'ORDER_PHONE_NUMBERS',
  SET_ORDER_STATUS: 'SET_ORDER_STATUS',
  ASSIGN_PHONE_NUMBER: 'ASSIGN_PHONE_NUMBER',
  DELETE_PHONE_NUMBER: 'DELETE_PHONE_NUMBER',
  ROUTE_TO_TEXML: 'ROUTE_TO_TEXML',
  ROUTE_TO_USER: 'ROUTE_TO_USER',
  SET_IS_SEARCHING: 'SET_IS_SEARCHING',
  SET_IS_ORDERING: 'SET_IS_ORDERING',
});

export const getCompanyPhoneNumbersAction = catchAsyncActionError(() => async dispatch => {
  const { data: response } = await telnyxPhoneNumberApi.getCompanyPhoneNumbers();

  return dispatch({
    type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.GET_COMPANY_PHONE_NUMBERS,
    payload: response?.data,
  });
});

export const searchAvailableNumbersAction = catchAsyncActionError(params => async dispatch => {
  dispatch({ type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.SET_IS_SEARCHING, payload: true });

  try {
    const { data: response } = await telnyxPhoneNumberApi.searchAvailableNumbers(params);

    return dispatch({
      type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.SEARCH_AVAILABLE_NUMBERS,
      payload: response?.data,
    });
  } finally {
    dispatch({ type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.SET_IS_SEARCHING, payload: false });
  }
});

export const clearSearchResultsAction = () => ({
  type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.CLEAR_SEARCH_RESULTS,
});

export const orderPhoneNumbersAction = catchAsyncActionError(body => async dispatch => {
  dispatch({ type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.SET_IS_ORDERING, payload: true });

  try {
    const { data } = await telnyxPhoneNumberApi.orderPhoneNumbers(body);

    return dispatch({
      type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.ORDER_PHONE_NUMBERS,
      payload: data,
    });
  } finally {
    dispatch({ type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.SET_IS_ORDERING, payload: false });
  }
});

export const pollOrderStatusAction = catchAsyncActionError(orderId => async dispatch => {
  const { data } = await telnyxPhoneNumberApi.getOrderStatus(orderId);

  return dispatch({
    type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.SET_ORDER_STATUS,
    payload: data,
  });
});

export const assignPhoneNumberAction = catchAsyncActionError(
  ({ phoneNumber, userId }) =>
    async dispatch => {
      await telnyxPhoneNumberApi.assignPhoneNumber({ phoneNumber, userId });

      return dispatch({
        type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.ASSIGN_PHONE_NUMBER,
        payload: { phoneNumber, userId },
      });
    },
);

export const deletePhoneNumberAction = catchAsyncActionError(phoneNumber => async dispatch => {
  await telnyxPhoneNumberApi.deletePhoneNumber(phoneNumber);

  return dispatch({
    type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.DELETE_PHONE_NUMBER,
    payload: phoneNumber,
  });
});

export const routePhoneNumberToTexmlAction = catchAsyncActionError(
  ({ texmlApplicationId, phoneNumber }) =>
    async dispatch => {
      const { data } = await telnyxPhoneNumberApi.routeToTexmlApplication({
        texmlApplicationId,
        phoneNumber,
      });

      return dispatch({
        type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.ROUTE_TO_TEXML,
        payload: data,
      });
    },
);

export const routePhoneNumberToUserAction = catchAsyncActionError(
  ({ phoneNumber }) =>
    async dispatch => {
      const { data } = await telnyxPhoneNumberApi.routeToUser({ phoneNumber });

      return dispatch({
        type: TELNYX_PHONE_NUMBERS_ACTION_TYPE.ROUTE_TO_USER,
        payload: data,
      });
    },
);
